<template>
    <div class="wrapper">
        <!-- <v-head></v-head> -->
        <v-head :class="isStickyVisible == true ? 'show-animate' : 'hide-animate'" class="sticky"></v-head>
        <div class="content-box"><!-- @mousewheel="handerScroll" -->
            <div class="content">
                <router-view></router-view>
                <div class="el-backtop" style="right: 40px; bottom: 40px;" @click="scrollToTop"><i class="el-icon-caret-top"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import vHead from './Header.vue';
export default {
    data() {
        return {
            lastScrollTop: 100,
            isStickyVisible: true
        };
    },
    beforeDestroy() {
        // console.log("销毁定时器")
    },
    components: {
        vHead
    },
    mounted: function() {
        // window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        handerScroll() {
            // 获取滚动条滚动的距离
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            // console.log('scrollTop----------', scrollTop);
            // 判断是否需要隐藏 sticky
            if (scrollTop > this.lastScrollTop) {
                this.isStickyVisible = false;
            } else if (scrollTop < this.lastScrollTop) {
                this.isStickyVisible = true;
            }
            this.lastScrollTop = scrollTop;
            // if (e.deltaY > 0) {
            //     console.log("鼠标向下滚动");
            //     this.vShow = 'none';
            // } else {
            //     console.log("鼠标向上滚动");
            //     this.vShow = 'block';
            // }
        },

        scrollToTop() {
            window.scrollTo({
                //滚动到元素位置
                //top: this.$refs[元素].offsetTop,//offsetTop 相对于offsetparent 定位,当有定位时，不准确。
                // top: sessionStorage.getItem('position'),//推荐使用，getBoundingClientRect 相对于当前视口的位置
                //top: 400//滚动到指定距离
                top: 0, //滚动到顶部
                //top: document.documentElement.scrollHeight,//滚动到底部
                behavior: 'smooth' // 平滑滚动
            });
        }
    }
};
</script>
<style>
.el-backtop {
    position: fixed;
    background-color: #fff;
    width: .5rem;
    height: .5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .25rem;
    box-shadow: 0 0 6px rgb(0 0 0 / 12%);
    cursor: pointer;
    z-index: 5;
}
.sticky {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100%;
    /* height:78px; */
}
.show-animate {
    animation: wrapper-gradient 0.25s linear;
}
@keyframes wrapper-gradient {
    0% {
        transform: translateY(-100%);
    }
    100% {
        transform: translateY(0);
    }
}
.hide-animate {
    animation: hide-gradient 0.25s linear;
    animation-fill-mode: forwards;
}
@keyframes hide-gradient {
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(-100%);
    }
}
</style>
